import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Button,
  MenuItem,
  Select,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Modal,
  IconButton,
  TextField,
  InputAdornment,
  Divider,
  Tooltip,
  alpha,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ManagementSidebar from "./ManagementSidebar";
import "./management.css";

import CloseIcon from "@mui/icons-material/Close";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useLocation, useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import { allowOnlyAlphabetsCityState } from "../IdentityVerification";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const AccountManagement = () => {
  const theme = localStorage.getItem("theme");
  const navigate = useNavigate();
  const location = useLocation();
  const openIndex = location.state?.openIndex;
  const { btncolor, brokerMarkets } = useSelector((state) => state);
  const [selectedSubAccount, setSelectedSubAccount] = useState("");
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState("");

  const [phone, setPhone] = useState("");
  const [getSubAccountsData, setGetSubAccountsData] = useState([]);

  const [subAccountListData, setSubAccountListData] = useState();

  // Search button disabled state
  const [isSearchButtonDisabled, setIsSearchButtonDisabled] = useState(false);

  const [openSubAccountModal, setOpenSubAccountModal] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [twofacodeforsubaccount, setTwofacodeforsubaccount] = useState("");
  const [subAccountModal, setSubAccountModal] = useState(false);

  const [changePswdModal, setChangePswdModal] = useState(false);
  const [delSubAccountModal, setDelSubAccountModal] = useState(false);
  const [changeEmailModal, setChangeEmailModal] = useState(false);
  const [unfreezeModal, setUnfreezeModal] = useState(false);
  const [disableSpotModal, setDisableSpotModal] = useState(false);
  const [enableSpotModal, setEnableSpotModal] = useState(false);
  const [enableFutureModal, setEnableFutureModal] = useState(false);
  const [disableFutureModal, setDisableFutureModal] = useState(false);
  const [enableOptionsModal, setEnableOptionsModal] = useState(false);
  const [disableOptionsModal, setDisableOptionsModal] = useState(false);
  const [enableConvertModal, setEnableConvertModal] = useState(false);
  const [disableConvertModal, setDisableConvertModal] = useState(false);
  const [enableOtcModal, setEnableOtcModal] = useState(false);
  const [disableOtcModal, setDisableOtcModal] = useState(false);
  const [enableCopytradeModal, setEnableCopytradeModal] = useState(false);
  const [disableCopytradeModal, setDisableCopytradeModal] = useState(false);
  const [enablePaymentsModal, setEnablePaymentsModal] = useState(false);
  const [disablePaymentsModal, setDisablePaymentsModal] = useState(false);
  const [enableIcoLaunchpadModal, setEnableIcoLaunchpadModal] = useState(false);
  const [disableIcoLaunchpadModal, setDisableIcoLaunchpadModal] =
    useState(false);
  const [enableLoansModal, setEnableLoansModal] = useState(false);
  const [disableLoansModal, setDisableLoansModal] = useState(false);
  const [enableP2PModal, setEnableP2PModal] = useState(false);
  const [disableP2PModal, setDisableP2PModal] = useState(false);
  const [enablePortfolioInvestModal, setEnablePortfolioInvestModal] =
    useState(false);
  const [disablePortfolioInvestModal, setDisablePortfolioInvestModal] =
    useState(false);
  const [enableEarnInterestModal, setEnableEarnInterestModal] = useState(false);
  const [disableEarnInterestModal, setDisableEarnInterestModal] =
    useState(false);

  const [hiddenEmail, setHiddenEmail] = useState("");

  const handleCloseSubAccount = () => (
    setSubAccountModal(false), resetValues()
  );

  const [signupSubAccountObj, setSignupSubAccountObj] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    repassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [spotStatus, setSpotStatus] = useState(null);
  const [futuresStatus, setFuturesStatus] = useState(null);
  const [optionsStatus, setOptionsStatus] = useState(null);
  const [convertStatus, setConvertStatus] = useState(null);
  const [otcStatus, setOtcStatus] = useState(null);
  const [isFreeze, setIsFreeze] = useState(null);
  const [isDelete, setIsDeleted] = useState(null);
  const [paymentsStatus, setPaymentsStatus] = useState(null);
  const [copyTradeStatus, setCopyTradeStatus] = useState(null);
  const [icoStatus, setIcoStatus] = useState(null);
  const [openNote, setOpenNote] = useState(false);
  const [text, setText] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [selectedMenu, setSelectedMenu] = useState("");

  const [remainingChar, setRemainingChar] = useState(500);
  const maxChar = 500;

  const [freezeModal, setFreezeModal] = useState(false);

  const [changePswdObj, setChangePswdObj] = useState({
    newPassword: "",
    cnfPassword: "",
  });
  const [subAccountPasswordMatch, setSubAccountPasswordMatch] = useState(false);
  const [changeEmailObj, setChangeEmailObj] = useState({ newEmail: "" });
  const [touched, setTouched] = useState(false);
  const [isSpotHasOpenOffersModal, setIsSpotHasOpenOffersModal] =
    useState(false);
  const [isFuturesHasOpenOffersModal, setIsFuturesHasOpenOffersModal] =
    useState(false);
  const [isOptionsHasOpenOffersModal, setIsOptionsHasOpenOffersModal] =
    useState(false);

  const resetValues = () => {
    setSignupSubAccountObj({
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      repassword: "",
    });
    setPhone("");
  };

  const getListOfAllSubAccounts = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/getAllSubAccounts`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;

      if (res.statusCode !== 0) {
        showToast("error", res.message);
      } else {
        setGetSubAccountsData(res["sub accounts"]);
      }
    } catch (error) {
      showToast("error", "Something went wrong!");
    }
  };

  useEffect(() => {
    getListOfAllSubAccounts();
  }, []);

  const handlePasswordChange = (e) => {
    setChangePswdObj({ ...changePswdObj, newPassword: e.target.value });
  };
  const validateEmail = (email) => {
    const pattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    return pattern.test(email) && !email.toLowerCase().includes("bob");
  };

  const handleCnfPasswordChange = (e) => {
    const cnfPassword = e.target.value;
    setChangePswdObj({ ...changePswdObj, cnfPassword });
    confirmSubAccountPassword(cnfPassword);
  };

  const confirmSubAccountPassword = (cnfPassword) => {
    setSubAccountPasswordMatch(cnfPassword === changePswdObj.newPassword);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleCloseNote = () => setOpenNote(false);
  const handleCloseFreezeModal = () => setFreezeModal(false);
  const handleCloseUnFreezeModal = () => setUnfreezeModal(false);

  const updateCharCount = () => {
    setRemainingChar(maxChar - text?.length);
  };

  const onInsertTxt = (e) => {
    setRemainingChar(maxChar - e.target.value.length);
  };
  const [emailError, setEmailError] = useState("");

  const createvalidateEmail = (email) => {
    const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email address");
    } else {
      setEmailError("");
    }
  };

  const handleChange = (e) => {
    setSignupSubAccountObj({
      ...signupSubAccountObj,
      [e.target.name]: e.target.value,
    });
  };

  const isPasswordValid = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$!@.])[a-zA-Z0-9$!.@]{8,35}$/.test(
      password
    );

  const confirmPassword = (repassword) => {
    return repassword === signupSubAccountObj.password;
  };

  const showHide = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    signupSubAccountData();
  };
  const isValid = () => {
    const { firstName, lastName, email, phone, password, repassword } =
      signupSubAccountObj;

    // Check for empty fields
    if (
      !firstName.trim() ||
      !lastName.trim() ||
      !email.trim() ||
      !phone.trim() ||
      !password ||
      !(repassword === password) ||
      emailError
    ) {
      return false;
    }
    return true;
  };

  const handleCreateSubAccount = () => {
    const parentId = localStorage.getItem("uuid");
    const payload = {
      parentId: parentId,
      email: signupSubAccountObj.email,
      firstName: signupSubAccountObj.firstName,
      middleName: signupSubAccountObj.middleName,
      lastName: signupSubAccountObj.lastName,
      countryCode: signupSubAccountObj.countryCode,
      phone: signupSubAccountObj.phone,
      password: signupSubAccountObj.password,
      securityCode: twofacodeforsubaccount,
    };

    axios
      .post(`${WEBSERVICE}assetManagement/createSubAccount`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setOpenSubAccountModal(false);
          setSubAccountModal(false);
          resetValues();
          setTwofacodeforsubaccount("");
          getListOfAllSubAccounts();
        }
      })
      .catch((error) => {
        showToast("error", "Internal Server Error");
      });
  };

  // Handle sub-account selection
  const handleEmailSelected = (event) => {
    const selected = event.target.value;
    setSelectedSubAccount(selected);
    setSelectedUuid(selected?.uuid);
    setSelectedEmail(selected?.email);
    setIsSearchButtonDisabled(selected?.email);
  };

  // Handle search button click
  const searchSubAccountDetails = () => {
    const twoFactorAuth = localStorage.getItem("twoFactorAuth");
    if (twoFactorAuth === "1") {
      setSelectedAction("Get sub account");
      setOpenSubAccountModal(true);
    } else {
      showToast(
        "error",
        "Please turn on Two Factor Authentication from Settings first"
      );
    }
  };
  const onActionSelected = (e) => {
    console.log(e.target.value);
    setSelectedMenu(e.target.value);

    switch (e.target.value) {
      case "Change Password":
        setChangePswdModal(true);
        break;
      case "Delete Sub Account":
        setDelSubAccountModal(true);
        break;
      case "Change Email":
        setChangeEmailModal(true);
        break;
      case "Freeze":
        hideEmail();
        setFreezeModal(true);
        break;
      case "Unfreeze":
        hideEmail();
        setUnfreezeModal(true);
        break;
      case "Disable Spot":
        setDisableSpotModal(true);
        break;
      case "Enable Spot":
        setEnableSpotModal(true);
        break;
      case "Enable Futures":
        setEnableFutureModal(true);
        break;
      case "Disable Futures":
        setDisableFutureModal(true);
        break;
      case "Enable Options":
        setEnableOptionsModal(true);
        break;
      case "Disable Options":
        setDisableOptionsModal(true);
        break;
      case "Enable Convert":
        setEnableConvertModal(true);
        break;
      case "Disable Convert":
        setDisableConvertModal(true);
        break;
      case "Enable Otc":
        setEnableOtcModal(true);
        break;
      case "Disable Otc":
        setDisableOtcModal(true);
        break;
      case "Enable Copy Trade":
        setEnableCopytradeModal(true);
        break;
      case "Disable Copy Trade":
        setDisableCopytradeModal(true);
        break;
      case "Enable Payments":
        setEnablePaymentsModal(true);
        break;
      case "Disable Payments":
        setDisablePaymentsModal(true);
        break;
      case "Enable ICO":
        setEnableIcoLaunchpadModal(true);
        break;
      case "Disable ICO":
        setDisableIcoLaunchpadModal(true);
        break;
      default:
        break;
    }
  };

  // Dynamic action handler inside modal confirm button
  const handleActionConfirm = () => {
    switch (selectedAction) {
      case "Create sub account":
        handleCreateSubAccount();
        break;
      case "Get sub account":
        fetchSubAccountDetails();
        break;
      case "twoFaCodeForNotesModal":
        updateSubAccountNotes();
        break;
      case "twofacodeforupdatepswdmodal":
        changePassword();
        break;
      case "twoFaCodeForDelSubAccModal":
        delSubAccount();
        break;
      case "twofacodeforupdateemailmodal":
        changeEmail();
        break;
      case "twoFaCodeForFreezeModal":
        freezeSubAccount();
        break;
      case "twoFaCodeForUnfreezeModal":
        unfreezeSubAccount();
        break;
      case "twofacodeforspotdisable":
        disableSpot();
        break;
      case "twofacodeforspotenable":
        enableSpot();
        break;
      case "twofacodeforenablefutures":
        enableFutures();
        break;
      case "twofacodefordisableFutures":
        disableFutures();
        break;
      case "twofacodeforenableoptions":
        enableOptions();
        break;
      case "twofacodefordisableoptions":
        disableOptions();
        break;
      case "twofacodeforenableconvert":
        enableConvert();
        break;
      case "twofacodefordisableconvert":
        disableConvert();
        break;
      case "twofacodeforenableotc":
        enableOtc();
        break;
      case "twofacodefordisableotc":
        disableOtc();
        break;
      case "twofacodeforenablecopytrade":
        enableCopytrade();
        break;
      case "twofacodefordisablecopytrade":
        disableCopytrade();
        break;
      case "twofacodeforenablepayments":
        enablePayments();
        break;
      case "twofacodefordisablepayments":
        disablePayments();
        break;
      case "twofacodeforenableico":
        enableIco();
        break;
      case "twofacodefordisableico":
        disableIco();
        break;
      default:
        break;
    }

    // Close modal and reset code after action
    setOpenSubAccountModal(false);
    setTwofacodeforsubaccount("");
  };

  // Handle opening modals (placeholder)
  const clickToOpenModal = (action) => {
    setSelectedAction(action);
    setOpenSubAccountModal(true);
  };

  const checkEmail = (value) => {
    if (value !== "") {
      const emailValue = value;
      const emailObj = { email: emailValue };
      const jsonString = JSON.stringify(emailObj);

      axios
        .post(`${WEBSERVICE}user/CheckEmail`, jsonString, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.error.error_data !== 0) {
            showToast("error", result.error.error_msg);
          } else {
            if (result.userResult.checkEmailPhoneFlag === 1) {
              showToast(
                "error",
                "Email already registered , please try with another email address"
              );
              setSignupSubAccountObj((prev) => ({ ...prev, email: "" }));
            } else {
              // No action needed, success case
            }
          }
        })
        .catch((error) => {
          showToast("error", "Internal Server Error");
        });
    } else {
      showToast("error", "Please Provide Email Id");
    }
  };

  const checkPhone = (value, country) => {
    const phone = value.target.value;
    const numberWithoutCountryCode = phone.replace(`+${country.dialCode}`, "");
    if (
      numberWithoutCountryCode !== "" &&
      numberWithoutCountryCode !== undefined
    ) {
      const phoneObj = {
        phone: numberWithoutCountryCode,
        countryCode: country.dialCode,
      };

      const jsonString = JSON.stringify(phoneObj);

      axios
        .post(`${WEBSERVICE}user/CheckPhone`, jsonString, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.error.error_data !== 0) {
            showToast("error", result.error.error_msg);
          } else {
            if (result.userResult.checkEmailPhoneFlag === 1) {
              showToast(
                "error",
                "Phone No. already registered, please try with another phone no."
              );
              // Clear phone input
              setSignupSubAccountObj((prevState) => ({
                ...prevState,
                phone: "",
              }));
            } else {
              // Success case if needed
            }
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error === "Token has been expired."
          ) {
            //logout
          } else {
            //logout
            showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
          }
        });
    }
  };

  const handleCountryChange = (countryCode) => {
    // Now you have the country code
    console.log("Selected country code:", countryCode);
  };

  const handleChangePhone = (value, country) => {
    const numberWithoutCountryCode = value.replace(`${country.dialCode}`, "");
    setSignupSubAccountObj({
      ...signupSubAccountObj,
      ["phone"]: numberWithoutCountryCode,
      ["countryCode"]: country.dialCode,
    });
    setPhone(value);
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const signupSubAccountData = () => {
    const twoFactorAuth = localStorage.getItem("twoFactorAuth");
    if (twoFactorAuth === "1") {
      console.log("TWO FA ON");
      setSelectedAction("Create sub account");
      setOpenSubAccountModal(true);
    } else {
      showToast(
        "error",
        "Please turn on Two Factor Authentication from settings first"
      );
    }
  };

  const fetchSubAccountDetails = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
    };

    axios
      .post(`${WEBSERVICE}assetManagement/getSubAccountDetails`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        console.log(response.data);
        const res = response.data;
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          const dataLists = res.user;

          const obj = {
            email: dataLists.email,
            userId: dataLists.userId,
            status: dataLists.status === 1 ? "Normal" : "Frozen",
            isLogin: dataLists.isLogin === 1 ? "Completed" : "Incomplete",
            twoFactorAuth: dataLists.twoFactorAuth === 0 ? 0 : 1,
            phone: `+${dataLists.countryCode}${dataLists.phone}`,
            note: dataLists.note,
            created: dataLists.created,
          };

          setText(dataLists.note);

          // Update account access states
          setSpotStatus(dataLists.spot);
          setFuturesStatus(dataLists.futures);
          setOptionsStatus(dataLists.options);
          setConvertStatus(dataLists.convert);
          setOtcStatus(dataLists.otc);
          setPaymentsStatus(dataLists.payments);
          setCopyTradeStatus(dataLists.copyTrade);
          setIcoStatus(dataLists.ico);
          setIsFreeze(dataLists.status);
          setIsDeleted(dataLists.isDeleted);

          setSubAccountListData(obj);
          setOpenSubAccountModal(false);
          setTwofacodeforsubaccount("");
        }
      })
      .catch((error) => {
        if (error.response?.data === "Token has been expired.") {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const hideEmail = () => {
    let email = selectedEmail;
    let maskedEmail = "";

    for (let i = 0; i < email.length; i++) {
      if (i > 2 && i < email.indexOf("@")) {
        maskedEmail += "*";
      } else {
        maskedEmail += email[i];
      }
    }

    setHiddenEmail(maskedEmail);
  };

  const updateSubAccountNotes = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      note: text,
      securityCode: twofacodeforsubaccount,
    };

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountNote`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        console.log("NOTES UPDATED", response.data.message);
        toast("success", response.data.message);
        setOpenNote(false);
      })
      .catch((error) => {
        console.error(
          "Error updating notes",
          error.response?.data?.message || error.message
        );
        showToast(
          "error",
          error.response?.data?.message || "Error updating notes"
        );
      });
  };

  const freezeSubAccount = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      status: 2,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/updateSubAccountStatus`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setFreezeModal(false);
      showToast("success", response.data.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error freezing sub-account:", error);
      showToast("error", "Something went wrong!");
    }
  };

  const unfreezeSubAccount = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      status: 1,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/updateSubAccountStatus`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data) {
        setUnfreezeModal(false);
        showToast("success", response.data.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error("Error unfreezing sub account:", error);
      showToast("error", "Failed to unfreeze sub account.");
    }
  };

  const changePassword = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      password: changePswdObj?.newPassword,
      securityCode: twofacodeforsubaccount,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/updateSubAccountPassword`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.statusCode !== 0) {
        showToast("error", response.data.message);
      } else {
        console.log(response.data);
        showToast("success", response.data.message);
        setChangePswdModal(false);
        window.location.reload();
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data.error === "Token has been expired."
      ) {
        // Custom logout function
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const changeEmail = async () => {
    console.log("email updated successfully");
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      email: changeEmailObj.newEmail,
      securityCode: twofacodeforsubaccount,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/updateSubAccountEmail`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.statusCode !== 0) {
        showToast("error", response.data.message);
      } else {
        console.log(response.data);
        showToast("success", response.data.message);
        setChangeEmailModal(false);
        window.location.reload();
      }
    } catch (error) {
      if (error.response?.data?.error === "Token has been expired.") {
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const delSubAccount = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/removeSubAccount`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;
      console.log(res);

      if (res.statusCode !== 0) {
        showToast("error", res.message); // Use your preferred alert system here
      } else {
        setDelSubAccountModal(false);
        showToast("success", res.message); // Success alert
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      if (error?.response?.data?.error === "Token has been expired.") {
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const enableSpot = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: 1,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/updateSubAccountAccess`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;
      if (res.statusCode !== 0) {
        showToast("error", res.message);
      } else {
        showToast("success", res.message);
        setEnableSpotModal(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      setEnableSpotModal(false);
      if (error.response?.data?.error === "Token has been expired.") {
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const disableSpot = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: 0,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        const res = response.data;

        if (res.statusCode !== 0) {
          if (res.message === "Updation failed") {
            setIsSpotHasOpenOffersModal(true);
          } else {
            showToast("error", res.message);
          }
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data.error === "Token has been expired."
        ) {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const enableFutures = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: 1,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    const jsonString = JSON.stringify(payload);

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setEnableFutureModal(false);
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        const reason = error.response ? error.response.data : {};
        if (reason.error === "Token has been expired.") {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const disableFutures = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: 0,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/updateSubAccountAccess`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;
      setDisableFutureModal(false);

      if (res.statusCode !== 0) {
        if (res.message === "Updation failed") {
          setIsFuturesHasOpenOffersModal(true);
        } else {
          showToast("error", res.message);
        }
      } else {
        showToast("success", res.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.log("ERROR", error);
      if (error?.response?.data?.error === "Token has been expired.") {
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const enableOptions = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: 1,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    const jsonString = JSON.stringify(payload);

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setEnableOptionsModal(false);
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error === "Token has been expired."
        ) {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const disableOptions = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: 0,
      payments: paymentsStatus,
      ico: icoStatus,
      // copyTrade: copyTradeStatus, // Uncomment if needed
    };

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setDisableOptionsModal(false);
        if (res.statusCode !== 0) {
          if (res.message === "Updation failed") {
            setIsOptionsHasOpenOffersModal(true);
          } else {
            showToast("error", res.message);
          }
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.error === "Token has been expired.") {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
          // data.alert('Could Not Connect To Server', 'warning');
        }
      });
  };

  const enablePayments = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: 1,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    const jsonString = JSON.stringify(payload);

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setEnablePaymentsModal(false);
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (error.response?.data?.error === "Token has been expired.") {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
          // data.alert('Could Not Connect To Server', 'warning');
        }
      });
  };

  const disablePayments = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: 0,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    const jsonString = JSON.stringify(payload);

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setDisablePaymentsModal(false);
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data.error === "Token has been expired."
        ) {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const enableIco = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: 1,
      copyTrade: copyTradeStatus,
    };

    const jsonString = JSON.stringify(payload);

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/updateSubAccountAccess`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;
      setEnableIcoLaunchpadModal(false);

      if (res.statusCode !== 0) {
        showToast("error", res.message);
      } else {
        showToast("success", res.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      const reason = error.response?.data;
      if (reason?.error === "Token has been expired.") {
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        // data.alert('Could Not Connect To Server', 'warning');
      }
    }
  };

  const disableIco = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: 0,
      copyTrade: copyTradeStatus,
    };

    try {
      const response = await fetch(
        `${WEBSERVICE}assetManagement/updateSubAccountAccess`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
          body: JSON.stringify(payload),
        }
      );

      const res = await response.json();

      setDisableIcoLaunchpadModal(false);

      if (res.statusCode !== 0) {
        showToast("error", res.message);
      } else {
        showToast("success", res.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      if (error?.response?.data?.error === "Token has been expired.") {
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const enableCopytrade = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: 1,
    };

    const jsonString = JSON.stringify(payload);

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/updateSubAccountAccess`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;
      setEnableCopytradeModal(false);

      if (res.statusCode !== 0) {
        showToast("error", res.message);
      } else {
        showToast("success", res.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      const reason = error.response;

      if (
        reason &&
        reason.data &&
        reason.data.error === "Token has been expired."
      ) {
        //logout
      } else {
        //logout
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        // data.alert('Could Not Connect To Server', 'warning');
      }
    }
  };

  const disableCopytrade = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: 0,
    };

    const jsonString = JSON.stringify(payload);

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setDisableCopytradeModal(false);
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (error.response?.data?.error === "Token has been expired.") {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const enableOtc = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: 1,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    const jsonString = JSON.stringify(payload);

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setEnableOtcModal(false);

        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        const reason = error.response?.data;

        if (reason?.error === "Token has been expired.") {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const disableOtc = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: convertStatus,
      otc: 0,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };
    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setDisableOtcModal(false);
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data.error === "Token has been expired."
        ) {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  const enableConvert = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: 1,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    const jsonString = JSON.stringify(payload);

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setEnableConvertModal(false);
        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        const reason = error.response;
        if (reason?.data?.error === "Token has been expired.") {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
          // data.alert('Could Not Connect To Server', 'warning');
        }
      });
  };

  const disableConvert = () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      securityCode: twofacodeforsubaccount,
      spot: spotStatus,
      convert: 0,
      otc: otcStatus,
      futures: futuresStatus,
      options: optionsStatus,
      payments: paymentsStatus,
      ico: icoStatus,
      copyTrade: copyTradeStatus,
    };

    axios
      .post(`${WEBSERVICE}assetManagement/updateSubAccountAccess`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const res = response.data;
        setDisableConvertModal(false);

        if (res.statusCode !== 0) {
          showToast("error", res.message);
        } else {
          showToast("success", res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (error.response?.data?.error === "Token has been expired.") {
          //logout
        } else {
          //logout
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      });
  };

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12, md: 2 }}>
        <ManagementSidebar index={openIndex} />
      </Grid>
      <Grid size={{ xs: 12, md: 10 }}>
        <Box sx={pageWrapper}>

          {/* ── Hero Banner ── */}
          <Box
            sx={{
              ...heroBanner,
              background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
            }}
          >
            <Box sx={heroContent}>
              <Box sx={heroIconBadge}>
                <ManageAccountsOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
              </Box>
              <Box>
                <Typography sx={heroTitle}>Account Management</Typography>
                <Typography sx={heroSubtitle}>
                  Create and manage sub-accounts, control trading permissions and monitor account activity
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* ── Main Card ── */}
          <Box sx={mainCard}>

            {/* Action bar */}
            <Box sx={actionBar}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                <GroupOutlinedIcon sx={{ fontSize: 18, color: "var(--text-color)", opacity: 0.55 }} />
                <Typography sx={sectionLabel}>Sub Accounts</Typography>
                {getSubAccountsData?.length > 0 && (
                  <Box sx={countBadge}>{getSubAccountsData.length}</Box>
                )}
              </Box>
              <ContainedButton
                variant="contained"
                size="small"
                startIcon={<AddCircleOutlineOutlinedIcon />}
                onClick={() => setSubAccountModal(true)}
                sx={createBtn}
              >
                Create Sub Account
              </ContainedButton>
            </Box>

            <Divider sx={{ borderColor: "rgba(125,125,125,0.12)" }} />

            {/* Search bar */}
            <Box sx={searchBar}>
              <Box sx={{ flex: 1, maxWidth: { md: 380 } }}>
                <Typography sx={fieldLabel}>Select Sub Account</Typography>
                <TextField
                  select
                  value={selectedSubAccount}
                  onChange={handleEmailSelected}
                  sx={modernFieldStyle}
                  fullWidth
                >
                  <MenuItem value=""><em>Select Sub Account</em></MenuItem>
                  {getSubAccountsData.map((account) => (
                    <MenuItem key={account.uuid} value={account}>
                      {account.email}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <ContainedButton
                  variant="contained"
                  sx={searchBtn}
                  onClick={searchSubAccountDetails}
                  disabled={!isSearchButtonDisabled}
                  startIcon={<SearchOutlinedIcon />}
                >
                  Search
                </ContainedButton>
              </Box>
            </Box>

            {/* Results table */}
            {subAccountListData?.email ? (
              <Box sx={resultsBlock}>
                <TableContainer component={Paper} sx={modernTableContainer}>
                  <Table sx={tableStyle}>
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        {[
                          "Email",
                          "User ID",
                          "Status",
                          "Date of Creation",
                          "Email Verification",
                          "Phone Number",
                          "Notes",
                          "2FA",
                          "Action",
                        ].map((h, i) => (
                          <TableCell key={i} sx={modernTableHeadCell}>{h}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={modernTableBodyRow}>
                        <TableCell sx={modernTableBodyCell}>
                          {subAccountListData?.email}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {subAccountListData?.userId}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              px: 1.2,
                              py: 0.35,
                              borderRadius: "20px",
                              fontSize: "0.72rem",
                              fontWeight: 700,
                              backgroundColor:
                                subAccountListData?.status === "Normal"
                                  ? "rgba(22,163,74,0.1)"
                                  : "rgba(239,68,68,0.1)",
                              color:
                                subAccountListData?.status === "Normal"
                                  ? "#16a34a"
                                  : "#ef4444",
                              border: `1px solid ${
                                subAccountListData?.status === "Normal"
                                  ? "rgba(22,163,74,0.25)"
                                  : "rgba(239,68,68,0.25)"
                              }`,
                            }}
                          >
                            {subAccountListData?.status}
                          </Box>
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {subAccountListData?.created}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {subAccountListData?.isLogin}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {subAccountListData?.phone}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Typography
                              sx={{
                                fontSize: "0.82rem",
                                color: "var(--text-color)",
                                opacity: 0.75,
                                maxWidth: 120,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {subAccountListData?.note
                                ? `${String(subAccountListData.note).substring(0, 18)}...`
                                : "—"}
                            </Typography>
                            <Tooltip title="Edit Note">
                              <IconButton
                                size="small"
                                onClick={() => setOpenNote(true)}
                                sx={{ color: btncolor, p: 0.25 }}
                              >
                                <EditOutlinedIcon sx={{ fontSize: 14 }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {subAccountListData?.twoFactorAuth === 0 ? (
                            <CancelOutlinedIcon
                              sx={{ color: "#ef4444", fontSize: 20, verticalAlign: "middle" }}
                            />
                          ) : (
                            <CheckCircleOutlineIcon
                              sx={{ color: "#16a34a", fontSize: 20, verticalAlign: "middle" }}
                            />
                          )}
                        </TableCell>
                        <TableCell sx={{ ...modernTableBodyCell, minWidth: 190 }}>
                          <FormControl fullWidth size="small">
                            <Select
                              displayEmpty
                              value={selectedMenu}
                              onChange={onActionSelected}
                              sx={actionSelectStyle}
                            >
                              <MenuItem value="">Select Action</MenuItem>
                              <MenuItem value="Change Password">Change Password</MenuItem>
                              <MenuItem value="Change Email">Change Email</MenuItem>
                              {isFreeze === 1 && (
                                <MenuItem value="Freeze">Freeze</MenuItem>
                              )}
                              {isFreeze === 2 && (
                                <MenuItem value="Unfreeze">Unfreeze</MenuItem>
                              )}
                              {brokerMarkets?.isSpot === 1 && spotStatus === 0 && (
                                <MenuItem value="Enable Spot">Enable Spot</MenuItem>
                              )}
                              {brokerMarkets?.isSpot === 1 && spotStatus === 1 && (
                                <MenuItem value="Disable Spot">Disable Spot</MenuItem>
                              )}
                              {brokerMarkets?.isFutures === 1 && futuresStatus === 0 && (
                                <MenuItem value="Enable Futures">Enable Futures</MenuItem>
                              )}
                              {brokerMarkets?.isFutures === 1 && futuresStatus === 1 && (
                                <MenuItem value="Disable Futures">Disable Futures</MenuItem>
                              )}
                              {brokerMarkets?.isOptions === 1 && optionsStatus === 0 && (
                                <MenuItem value="Enable Options">Enable Options</MenuItem>
                              )}
                              {brokerMarkets?.isOptions === 1 && optionsStatus === 1 && (
                                <MenuItem value="Disable Options">Disable Options</MenuItem>
                              )}
                              {brokerMarkets?.isConvert === 1 && convertStatus === 0 && (
                                <MenuItem value="Enable Convert">Enable Convert</MenuItem>
                              )}
                              {brokerMarkets?.isConvert === 1 && convertStatus === 1 && (
                                <MenuItem value="Disable Convert">Disable Convert</MenuItem>
                              )}
                              {brokerMarkets?.isOtc === 1 && otcStatus === 0 && (
                                <MenuItem value="Enable Otc">Enable OTC</MenuItem>
                              )}
                              {brokerMarkets?.isOtc === 1 && otcStatus === 1 && (
                                <MenuItem value="Disable Otc">Disable OTC</MenuItem>
                              )}
                              {brokerMarkets?.isCopyTrade === 1 && copyTradeStatus === 0 && (
                                <MenuItem value="Enable Copy Trade">Enable Copy Trade</MenuItem>
                              )}
                              {brokerMarkets?.isCopyTrade === 1 && copyTradeStatus === 1 && (
                                <MenuItem value="Disable Copy Trade">Disable Copy Trade</MenuItem>
                              )}
                              {/* {paymentsStatus === 0 && (
                                <MenuItem value="Enable Payments">Enable Payments</MenuItem>
                              )}
                              {paymentsStatus === 1 && (
                                <MenuItem value="Disable Payments">Disable Payments</MenuItem>
                              )} */}
                              {brokerMarkets?.isIco === 1 && icoStatus === 0 && (
                                <MenuItem value="Enable ICO">Enable ICO</MenuItem>
                              )}
                              {brokerMarkets?.isIco === 1 && icoStatus === 1 && (
                                <MenuItem value="Disable ICO">Disable ICO</MenuItem>
                              )}
                              {isDelete === 0 && (
                                <MenuItem value="Delete Sub Account">Delete Sub Account</MenuItem>
                              )}
                              {isDelete === 1 && (
                                <MenuItem value="Sub Account Deleted">Sub Account Deleted</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ) : (
              <Box sx={emptyState}>
                <InboxOutlinedIcon sx={emptyIcon} />
                <Typography sx={emptyText}>
                  Search for a sub account to view its details
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      {/* subAccountModal */}
      <ModalContent
        open={subAccountModal}
        onClose={handleCloseSubAccount}
        title={`Create Sub Account`}
      >
        <form onSubmit={handleSubmit} autoComplete="off" className="mt-2">
          <Grid container spacing={2}>
            <Grid size={4}>
              <TextField
                autoComplete="off"
                required
                fullWidth
                name="firstName"
                label="First Name"
                value={signupSubAccountObj.firstName}
                onChange={handleChange}
                onKeyDown={allowOnlyAlphabetsCityState}
                inputProps={{
                  pattern: "[A-Za-zÀ-ÿ\\s -\\uFFFF\\x0A\\x0D\\x09]{1,40}",
                }}
              />
            </Grid>

            <Grid size={4}>
              <TextField
                autoComplete="off"
                fullWidth
                name="middleName"
                label="Middle Name"
                value={signupSubAccountObj.middleName}
                onChange={handleChange}
                onKeyDown={allowOnlyAlphabetsCityState}
              />
            </Grid>

            <Grid size={4}>
              <TextField
                autoComplete="off"
                required
                fullWidth
                name="lastName"
                label="Last Name"
                value={signupSubAccountObj.lastName}
                onChange={handleChange}
                onKeyDown={allowOnlyAlphabetsCityState}
              />
            </Grid>

            <Grid size={12}>
              <TextField
                autoComplete="new-email"
                required
                fullWidth
                name="email"
                label="Email"
                value={signupSubAccountObj.email}
                onChange={(e) => {
                  handleChange(e);
                  createvalidateEmail(e.target.value);
                }}
                onBlur={(e) => createvalidateEmail(e.target.value)}
                onFocus={(e) => e.target.setAttribute("autocomplete", "nope")}
                error={!!emailError}
                helperText={emailError}
              />
            </Grid>

            <Grid size={12}>
              <Box>
                <PhoneInput
                  country={"us"}
                  value={phone}
                  onChange={handleChangePhone}
                  onBlur={checkPhone}
                  onCountryChange={handleCountryChange}
                  inputProps={{
                    name: "phone",
                    required: true,
                    minLength: 8,
                    maxLength: 15,
                  }}
                  inputStyle={{
                    width: "100%",
                    paddingLeft: "53px",
                    height: "56px", // Matches Material UI default input height
                    // borderColor: isDirty && isInvalid ? '#d32f2f' : undefined,
                    borderRadius: 4,
                    backgroundColor: "transparent",
                    color: theme === "dark" ? "white" : "black",
                  }}
                  buttonStyle={{
                    backgroundColor: "transparent",
                    color: theme === "dark" ? "white" : "black",
                    border: "none",
                  }}
                  dropdownStyle={{
                    backgroundColor: theme === "dark" ? "#333" : "#fff",
                    color: theme === "dark" ? "white" : "black",
                  }}
                  containerStyle={{
                    width: "100%",
                  }}
                />
              </Box>
            </Grid>

            <Grid size={12}>
              <TextField
                autoComplete="new-password"
                className="formPassword"
                required
                fullWidth
                type={showPassword ? "text" : "password"}
                name="password"
                label="Password"
                value={signupSubAccountObj.password}
                onChange={handleChange}
                error={
                  signupSubAccountObj.password.length > 0 &&
                  !isPasswordValid(signupSubAccountObj.password)
                }
                sx={{
                  "& input:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0px 1000px transparent inset",
                    WebkitTextFillColor: "#fff",
                    transition: "background-color 5000s ease-in-out 0s",
                  },
                }}
                helperText={
                  signupSubAccountObj.password.length > 0 &&
                  !isPasswordValid(signupSubAccountObj.password)
                    ? "The password should be of minimum 8, maximum 35 characters and must contain at least one uppercase, one lowercase, a number and a special character (only $ @  . ! are allowed in special characters)."
                    : " "
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={showHide} edge="end">
                        <FontAwesomeIcon
                          icon={showPassword ? faEye : faEyeSlash}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid size={12}>
              <TextField
                autoComplete="new-password"
                required
                fullWidth
                type="password"
                name="repassword"
                label="Retype Password"
                value={signupSubAccountObj.repassword}
                onChange={handleChange}
                error={
                  signupSubAccountObj.repassword.length > 0 &&
                  !confirmPassword(signupSubAccountObj.repassword)
                }
                helperText={
                  signupSubAccountObj.repassword.length > 0 ? (
                    !confirmPassword(signupSubAccountObj.repassword) ? (
                      "Password Mismatched"
                    ) : (
                      <span className="text-success">Password Matched</span>
                    )
                  ) : null
                }
              />
            </Grid>

            <Grid size={12}>
              <ContainedButton
                variant="contained"
                fullWidth
                type="submit"
                disabled={!isValid()}
              >
                Submit
              </ContainedButton>
            </Grid>
          </Grid>
        </form>
      </ModalContent>

      {/* Sub-Account Modal */}

      <ModalContent
        open={openSubAccountModal}
        onClose={() => (
          setOpenSubAccountModal(false), setTwofacodeforsubaccount("")
        )}
        title={`Security Authentication`}
      >
        <Typography variant="body2" gutterBottom sx={{ textAlign: "center" }}>
          Input OTP from your Google Authenticator
        </Typography>
        <TextField
          autoComplete="off"
          fullWidth
          type="number"
          variant="outlined"
          placeholder="Two-Factor Authenticator code"
          value={twofacodeforsubaccount}
          onChange={(e) => setTwofacodeforsubaccount(e.target.value)}
          onWheel={(e) => e.target.blur()}
          autoFocus
          margin="normal"
        />
        <ContainedButton
          variant="contained"
          fullWidth
          onClick={() => handleActionConfirm()}
          sx={{ mt: 3 }}
        >
          Confirm
        </ContainedButton>
      </ModalContent>

      <ModalContent open={openNote} onClose={handleCloseNote} title={`Notes`}>
        <Typography sx={{ mb: 2 }}>{selectedEmail}</Typography>
        <TextField
          fullWidth
          multiline
          rows={10}
          value={text}
          name="text"
          onChange={(e) => setText(e.target.value)}
          onKeyPress={updateCharCount}
          onKeyUp={onInsertTxt}
          required
          inputProps={{ maxLength: maxChar }}
          sx={{ mb: 1 }}
        />
        <Typography variant="body2" sx={{ mb: 2 }}>
          <span className="counterTxt">{remainingChar}</span>/{maxChar}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <ContainedButton
            variant="contained"
            disabled={text?.trim() === ""}
            onClick={() => clickToOpenModal("twoFaCodeForNotesModal")}
          >
            Save
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent open={freezeModal} onClose={handleCloseFreezeModal}>
        <Typography id="freeze-modal-description" sx={{ textAlign: "justify" }}>
          Are you sure you want to freeze this account {hiddenEmail}? All open
          orders will be cancelled, and the API keys will be deleted. You will
          not have login access.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <OutlinedButton
            variant="outlined"
            sx={{
              mr: 2,
            }}
            onClick={handleCloseFreezeModal}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton
            variant="contained"
            onClick={() => clickToOpenModal("twoFaCodeForFreezeModal")}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent open={unfreezeModal} onClose={handleCloseUnFreezeModal}>
        <Typography id="unfreeze-modal-description" sx={{ mt: 2 }}>
          Are you sure you want to unfreeze this account {hiddenEmail}?
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <OutlinedButton
            variant="outlined"
            sx={{
              mr: 2,
            }}
            onClick={handleCloseUnFreezeModal}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton
            variant="contained"
            onClick={() => clickToOpenModal("twoFaCodeForUnfreezeModal")}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={changePswdModal}
        onClose={() => setChangePswdModal(false)}
        title={"Change Password"}
      >
        <Box>
          <TextField
            type={showPassword ? "text" : "password"}
            fullWidth
            variant="outlined"
            placeholder="Please enter Password"
            id="newpassword"
            name="newPassword"
            value={changePswdObj.newPassword}
            onChange={handlePasswordChange}
            error={
              changePswdObj.newPassword !== "" &&
              !isPasswordValid(changePswdObj.newPassword)
            }
            helperText={
              changePswdObj.newPassword !== "" &&
              !isPasswordValid(changePswdObj.newPassword)
                ? "The password should be of minimum 8, maximum 35 characters and must contain at least one uppercase, one lowercase, a number and a special character (only $ @ . ! are allowed)."
                : ""
            }
            InputProps={{
              endAdornment: (
                <IconButton onClick={toggleShowPassword}>
                  <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                </IconButton>
              ),
            }}
            required
          />

          <TextField
            type="text"
            fullWidth
            variant="outlined"
            placeholder="Please confirm password again"
            name="cnfPassword"
            value={changePswdObj.cnfPassword}
            onChange={handleCnfPasswordChange}
            sx={{ mt: 2 }}
            error={changePswdObj.cnfPassword !== "" && !subAccountPasswordMatch}
            helperText={
              changePswdObj.cnfPassword !== "" && !subAccountPasswordMatch
                ? "Passwords do not match."
                : ""
            }
            required
          />

          <Box display="flex" justifyContent="center" mt={4}>
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodeforupdatepswdmodal")}
              disabled={
                !isPasswordValid(changePswdObj.newPassword) ||
                !subAccountPasswordMatch
              }
            >
              Confirm
            </ContainedButton>
          </Box>
        </Box>
      </ModalContent>

      <ModalContent
        open={changeEmailModal}
        onClose={() => setChangeEmailModal(false)}
        title={"Change Email"}
      >
        <Box>
          <TextField
            fullWidth
            id="newEmail"
            name="newEmail"
            placeholder="Please enter new email"
            variant="outlined"
            value={changeEmailObj.newEmail}
            onChange={(e) =>
              setChangeEmailObj({
                ...changeEmailObj,
                newEmail: e.target.value,
              })
            }
            onBlur={() => setTouched(true)}
            error={touched && !validateEmail(changeEmailObj.newEmail)}
            helperText={
              touched && !validateEmail(changeEmailObj.newEmail)
                ? "Enter a valid email"
                : ""
            }
            required
          />

          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <ContainedButton
              variant="contained"
              disabled={!validateEmail(changeEmailObj.newEmail)}
              onClick={() => clickToOpenModal("twofacodeforupdateemailmodal")}
            >
              Confirm
            </ContainedButton>
          </Box>
        </Box>
      </ModalContent>

      <ModalContent
        open={delSubAccountModal}
        onClose={() => setDelSubAccountModal(false)}
      >
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          Are you sure you want to delete this sub account?
        </Typography>
        <Typography variant="body2" sx={{ textAlign: "justify", my: 3, pb: 3 }}>
          This action is irreversible. You will have an additional quota to
          create a new one. You can delete your sub-account, if the sub-account
          has assets then it will transfer to your main wallet, open orders then
          it will cancel and settled asset will transfer to your main wallet,
          positions then it will settled and asset will transfer to your main
          wallet or API keys then it will deleted. Please note that you will not
          be able to create a new sub-account with the email you used for the
          deleted sub-account.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <ContainedButton
            variant="contained"
            sx={{ mr: 2 }}
            onClick={() => clickToOpenModal("twoFaCodeForDelSubAccModal")}
          >
            Confirm
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            onClick={() => setDelSubAccountModal(false)}
          >
            Cancel
          </OutlinedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={enableSpotModal}
        onClose={() => setEnableSpotModal(false)}
      >
        <Typography align="center" sx={{ px: 3 }}>
          Enable Spot Trading for your sub account ?
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <ContainedButton
            variant="contained"
            onClick={() => clickToOpenModal("twofacodeforspotenable")}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>

      {/* disableSpotModal */}

      <ModalContent
        open={disableSpotModal}
        onClose={() => setDisableSpotModal(false)}
      >
        <Typography variant="h6">
          Disable Spot Trading for your sub account?
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <ContainedButton
            variant="contained"
            onClick={() => clickToOpenModal("twofacodeforspotdisable")}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={isSpotHasOpenOffersModal}
        onClose={() => setIsSpotHasOpenOffersModal(false)}
      >
        <Box sx={{ textAlign: "center" }}>
          <i
            className="fa fa-exclamation-triangle text-warning d-flex justify-content-center mb-3"
            style={{ fontSize: "30px" }}
          ></i>
          <Typography id="spot-open-offers-description" sx={{ px: 3 }}>
            You cannot disable Spot as your sub account has open offers in this
            market.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <ContainedButton
            variant="contained"
            onClick={() => setIsSpotHasOpenOffersModal(false)}
          >
            Ok
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={enableFutureModal}
        onClose={() => setEnableFutureModal(false)}
      >
        <Typography variant="body1" sx={{ px: 3, textAlign: "center" }}>
          Enable Futures Trading for your sub account ?
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <ContainedButton
            variant="contained"
            onClick={() => clickToOpenModal("twofacodeforenablefutures")}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={disableFutureModal}
        onClose={() => setDisableFutureModal(false)}
      >
        <Typography
          id="disable-future-modal-description"
          sx={{ textAlign: "center", px: 3, mt: 2 }}
        >
          Disable Futures Trading for your sub account?
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 4,
          }}
        >
          <ContainedButton
            variant="contained"
            onClick={() => clickToOpenModal("twofacodefordisableFutures")}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={isFuturesHasOpenOffersModal}
        onClose={() => setIsFuturesHasOpenOffersModal(false)}
      >
        <Box>
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <i
                  className="fa fa-exclamation-triangle text-warning d-flex justify-content-center mb-3"
                  style={{ fontSize: "30px" }}
                ></i>
              </div>
              <Typography
                id="futures-warning-description"
                sx={{ px: 3 }}
                className="text-center"
              >
                You cannot disable Futures as your sub account has open offers
                or wallet balances in this market.
              </Typography>
            </div>
          </div>
          <div className="col-md-12">
            <div className="d-flex justify-content-center mt-4">
              <ContainedButton
                variant="contained"
                onClick={() => setIsFuturesHasOpenOffersModal(false)}
              >
                Ok
              </ContainedButton>
            </div>
          </div>
        </Box>
      </ModalContent>

      <ModalContent
        open={enableOptionsModal}
        onClose={() => setEnableOptionsModal(false)}
      >
        <Typography variant="body1" align="center" sx={{ px: 3 }}>
          Enable Options Trading for your sub account?
        </Typography>
        <Box display="flex" justifyContent="center" mt={4}>
          <ContainedButton
            variant="contained"
            onClick={() => clickToOpenModal("twofacodeforenableoptions")}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={disableOptionsModal}
        onClose={() => setDisableOptionsModal(false)}
      >
        <Typography sx={{ textAlign: "center" }}>
          Disable Options Trading for your sub account?
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <ContainedButton
            variant="contained"
            onClick={() => clickToOpenModal("twofacodefordisableoptions")}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={isOptionsHasOpenOffersModal}
        onClose={() => setIsOptionsHasOpenOffersModal(false)}
      >
        <Box sx={{ textAlign: "center" }}>
          <i
            className="fa fa-exclamation-triangle text-warning d-flex justify-content-center mb-3"
            style={{ fontSize: "30px" }}
          ></i>
          <Typography sx={{ px: 3 }}>
            You cannot disable Options as your sub account has open offers or
            wallet balances in this market.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <ContainedButton
            variant="contained"
            onClick={() => setIsOptionsHasOpenOffersModal(false)}
          >
            Ok
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={enableLoansModal}
        onClose={() => setEnableLoansModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable Loans for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => setEnableLoansModal(false)}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disableLoansModal}
        onClose={() => setDisableLoansModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable Loans for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => setDisableLoansModal(false)}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={enableP2PModal}
        onClose={() => setEnableP2PModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable P2P for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => setEnableP2PModal(false)}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disableP2PModal}
        onClose={() => setDisableP2PModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable P2P for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => setDisableP2PModal(false)}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={enablePaymentsModal}
        onClose={() => setEnablePaymentsModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable Payments for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodeforenablepayments")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disablePaymentsModal}
        onClose={() => setDisablePaymentsModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable Payments for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodefordisablepayments")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={enableIcoLaunchpadModal}
        onClose={() => setEnableIcoLaunchpadModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable ICO Launchpad for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodeforenableico")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disableIcoLaunchpadModal}
        onClose={() => setDisableIcoLaunchpadModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable ICO Launchpad for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodefordisableico")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={enablePortfolioInvestModal}
        onClose={() => setEnablePortfolioInvestModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable Portfolio Invest for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => setEnablePortfolioInvestModal(false)}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disablePortfolioInvestModal}
        onClose={() => setDisablePortfolioInvestModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable Portfolio Invest for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => setDisablePortfolioInvestModal(false)}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={enableEarnInterestModal}
        onClose={() => setEnableEarnInterestModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable Earn Interest for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => setEnableEarnInterestModal(false)}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disableEarnInterestModal}
        onClose={() => setDisableEarnInterestModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable Earn Interest for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => setDisableEarnInterestModal(false)}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={enableCopytradeModal}
        onClose={() => setEnableCopytradeModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable Copy Trade for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => (
                setEnableCopytradeModal(false),
                clickToOpenModal("twofacodeforenablecopytrade")
              )}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disableCopytradeModal}
        onClose={() => setDisableCopytradeModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable Copy Trade for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodefordisablecopytrade")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={enableOtcModal}
        onClose={() => setEnableOtcModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable OTC for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodeforenableotc")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disableOtcModal}
        onClose={() => setDisableOtcModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable OTC for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodefordisableotc")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={enableConvertModal}
        onClose={() => setEnableConvertModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Enable Crypto Convert for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodeforenableconvert")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>

      <ModalContent
        open={disableConvertModal}
        onClose={() => setDisableConvertModal(false)}
      >
        <div className="row">
          <div className="col-md-12">
            <p className="pl-3 pr-3 text-center">
              Disable Crypto Convert for your sub account ?
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center ml-5 mt-4">
            <ContainedButton
              variant="contained"
              onClick={() => clickToOpenModal("twofacodefordisableconvert")}
            >
              Confirm
            </ContainedButton>
          </div>
        </div>
      </ModalContent>
    </Grid>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 1.5, md: 3 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const actionBar = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: { xs: 2, md: 3 },
  py: 2,
  backgroundColor: "var(--body-color-less2)",
  flexWrap: "wrap",
  gap: 1.5,
};

const sectionLabel = {
  fontSize: "0.9rem",
  fontWeight: 700,
  color: "var(--text-color)",
  letterSpacing: "0.01em",
};

const countBadge = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 22,
  height: 22,
  borderRadius: "11px",
  backgroundColor: "rgba(125,125,125,0.15)",
  color: "var(--text-color)",
  fontSize: "0.7rem",
  fontWeight: 700,
  px: 0.75,
};

const createBtn = {
  height: 36,
  px: 2,
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.82rem",
  letterSpacing: "0.01em",
};

const searchBar = {
  display: "flex",
  alignItems: "flex-end",
  gap: 2,
  px: { xs: 2, md: 3 },
  py: 2.5,
  flexWrap: "wrap",
};

const fieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.55,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  mb: 0.75,
};

const modernFieldStyle = {
  "& .MuiInputBase-root": {
    height: "48px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.9rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiInputLabel-root": { display: "none" },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
};

const searchBtn = {
  height: "48px",
  px: 3,
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "0.85rem",
  textTransform: "none",
  letterSpacing: "0.01em",
  whiteSpace: "nowrap",
};

const resultsBlock = {
  px: { xs: 2, md: 3 },
  pb: 3,
};

const modernTableContainer = {
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "none",
  overflow: "auto",
  backgroundColor: "var(--body-color-less)",
};

const tableStyle = {
  minWidth: 900,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};

const actionSelectStyle = {
  borderRadius: "8px",
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  fontSize: "0.82rem",
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiSelect-select": { color: "var(--text-color)" },
};

const emptyState = {
  textAlign: "center",
  py: 8,
  px: 2,
};

const emptyIcon = {
  fontSize: 52,
  color: "var(--text-color)",
  opacity: 0.3,
  mb: 1,
};

const emptyText = {
  fontSize: "0.92rem",
  color: "var(--text-color)",
  opacity: 0.55,
};

export default AccountManagement;
